<template>
  <div class="offer-active-ladder">
    <!-- 满金额减金额 循环 -->
    <template v-for="(ladder, index) in listData">


      <div v-if="ruletype == 2 && activetype == 1" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">每满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">减金额</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">金额不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_amount" class="input-style" placeholder="请输入" />
          </div>
        </div>
      </div>

      <!-- 满金额送商品 循环 -->
      <div v-if="ruletype == 2 && activetype == 2" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">每满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">商品数量不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_num" class="input-style" placeholder="请输入" />
          </div>
        </div>
      </div>

      <!-- 满数量送商品 循环 -->
      <div v-if="ruletype == 2 && activetype == 3" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">每满数量</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">商品数量不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_num" class="input-style" placeholder="请输入" />
          </div>
        </div>
      </div>

      <!-- 满金额减金额且送商品 循环 -->
      <div v-if="ruletype == 2 && activetype == 7" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">每满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">减金额</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">金额不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_amount" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.num" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">商品数量不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_num" class="input-style" placeholder="请输入" />
          </div>
        </div>
      </div>

      <!-- 满金额打折且送商品 循环 -->
      <div v-if="ruletype == 2 && activetype == 8" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">每满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">打折（不参与循环）</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.num" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">商品数量不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_num" class="input-style" placeholder="请输入" />
          </div>
        </div>
      </div>

      <!-- 满数量打折且送商品 循环 -->
      <div v-if="ruletype == 2 && activetype == 9" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">每满数量</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">打折（不参与循环）</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.num" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">商品数量不超过</div>
          <div class="input">
            <el-input v-model="ladder.max_num" class="input-style" placeholder="请输入" />
          </div>
        </div>
      </div>



      <!-- 满金额减金额 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 1" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">减金额</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满金额送商品 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 2" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满金额打折 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 5" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">打折</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满数量打折 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 4" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满数量</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">打折</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满数量送商品 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 3" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满数量</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满金额减金额且送商品 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 7" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">减金额</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.num" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满金额打折且送商品 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 8" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">打折</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.num" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满数量打折且送商品 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 9" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满数量</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">打折</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">赠送商品数量</div>
          <div class="input">
            <el-input v-model="ladder.num" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>

      <!-- 满金额送金额 阶梯 -->
      <div v-if="ruletype == 1 && activetype == 6" :key="index" class="ladder">
        <div class="ladderItem">
          <div class="name">满金额</div>
          <div class="input">
            <el-input v-model="ladder.buy" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">送金额</div>
          <div class="input">
            <el-input v-model="ladder.derate" class="input-style" placeholder="请输入" />
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">活动显示</div>
          <div class="input">
            <el-checkbox v-model="ladder.activity_display" @change="handleCheckboxChange(ladder.ladderId)"></el-checkbox>
          </div>
        </div>
        <div class="ladderItem">
          <div class="name">操作</div>
          <div class="input">
            <el-button round size="small" style="width: 80px;" @click="handleDelete(ladder.ladderId)">删除</el-button>
          </div>
        </div>
      </div>


    </template>

  </div>
</template>
<script>


export default {
  name: 'OffersactiveLadder',
  props: {
    ruletype: {
      type: [Number, String],
      required: true,
      default: () => 2
    },
    activetype: {
      type: [Number, String],
      required: true,
      default: () => 1
    }
  },
  mounted() {

    this.listData.push(this.newTemp())
  }, 
  data() {
    return {
      ladder: {
        man: '',
        jian: '',
        limt: '',
        checked: ''
      },
      listData: [],
      temp: {
        ladderId: "",
        buy: '', // 固定为第一个参数
        derate: '', // 固定为第二个参数
        activity_display: '', // 是否显示：0不显示 1显示
        max_amount: '', // 最大优惠金额/ 折扣
        num: '', // 赠送数量
        max_num: '', // 最大赠送数量
      }
    }
  },
  methods: {
    newTemp() {
      const obj = JSON.parse(JSON.stringify(this.temp))
      obj.ladderId = new Date().valueOf()
      return obj
    },
    changeRule() {
      this.listData = [this.newTemp()]
    },
    addLevel() {
      this.listData.push(this.newTemp())
    },
    handleDelete(id) {
      // 根据ladderId删除this.listData数组中ladderId == id的元素
      if (this.listData.length == 1) {
        this.$message.warning('至少需要一个阶梯')
        return
      }
      const index = this.listData.findIndex(item => item.ladderId === id)
      this.listData.splice(index, 1)
    },
    handleCheckboxChange(id) {
      this.listData.forEach(item => {
        if (item.ladderId == id) {
          item.activity_display = true
        } else {
          item.activity_display = false
        }
      })
    },
    setData(info) {
      if (!info) {
        this.listData = []
        this.changeRule()
      }
      const data = JSON.parse(JSON.stringify(info))
      data.forEach((item, index) => {
        item.ladderId  = `${new Date().valueOf()}-${index}`
        if (item.activity_display == 0) {
          item.activity_display = false
        } else {
          item.activity_display = true
        }
      })
      this.listData = data
    },
    getData() {
      return this.listData
    }
  }
}
</script>
<style scoped>
.offer-active-ladder {}

.ladder {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.ladderItem {
  width: 18%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 20px;
}

.input {
  width: 100%;
  display: flex;
  justify-content: center;
}

.input-style {
  width: 100%;
  max-width: 100%;
}

.name {
  margin-bottom: 10px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/mall/OffersactiveLadder.vue